import { cn } from '@/context/global/utils/cn';

export type IconRepeatProps = {
  className?: string;
  size?: number;
};

export default function IconRepeat({ className = '', size = 32 }: IconRepeatProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-white', className)}
    >
      <path
        d="M5.97333 20.0001C7.13333 23.6934 10.5867 26.3334 14.6667 26.3334H17.3333C22.12 26.3334 26 22.4534 26 17.6667V14.3334"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 17.6667V14.3334C6 9.54671 9.88 5.66671 14.6667 5.66671H17.3333C21.4133 5.66671 24.8667 8.30671 26.0267 12.0001"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66699 17.6667L6.00033 14.3334L3.33366 17.6667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.333 14.3334L25.9997 17.6667L28.6663 14.3334"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
